import Dropzone from "react-dropzone";
import isEmpty from "src/utils/helpers";
import {Formik} from "formik";
import React, {Component} from "react";
import * as Yup from "yup";
import {toastr} from "react-redux-toastr";
import {hideModal} from "src/actions/modal.actions";
import {connect} from 'react-redux'
import {getModalData} from "src/selectors";
import {
    createAccountDocument,
    editAccountDocument,
    getAccountDocuments,
    deleteAccountDocument
} from "src/actions/accountDetailsActions/documents.actions";


class AddDocumentModal extends Component {

    state = {
        isCreating: false,
    }

    DocumentSchema = Yup.object().shape({
        document: Yup.mixed().nullable().required('Required'),
        description: Yup.string(),
    });

    handleCreateDocument = (values) => {
        this.setState({
            isSubmitting: true
        })
        const {modalProps} = this.props;

        this.setState({isCreating: true})

        let formData = new FormData();
        formData.append("document", values.document);
        let data = {name: values.name, description: values.description, isRestricted: values.restricted}

        this.props.createAccountDocument(modalProps.accountId, formData, data).then((response) => {
            this.setState({isCreating: false})

            if (response.success === true) {
                this.props.getAccountDocuments(modalProps.accountId);
                toastr.success(values.document.name + ' uploaded successfully', { timeOut: 2000, position: 'top-center' });
                this.props.hideModal()
            } else {
                let errorMessage = 'Something went wrong';
                if (response && response.error && response.error.message) errorMessage = response.error.message;
                toastr.error(errorMessage, { timeOut: 2000, position: 'top-center' });
                this.setState({
                    isSubmitting: false
                })
            }
        });
    }

    handleEditDocument = (values) => {
        const {modalProps} = this.props
        let payload = {accountId: modalProps.accountId, id: modalProps.document.id,
            name: values.name, description: values.description, restricted: values.restricted }

            this.props.editAccountDocument(payload).then((response) => {
            if (response.success === true) {
                this.props.getAccountDocuments(modalProps.accountId);
                toastr.success(values.name + ' edited successfully', { timeOut: 2000, position: 'top-center' });
                this.props.hideModal()
            } else {
                let errorMessage = 'Something went wrong';
                if (response && response.error && response.error.message) errorMessage = response.error.message;
                toastr.error(errorMessage, { timeOut: 2000, position: 'top-center' });
            }
        })
    }

    handleDeleteDocument = () => {
        const {modalProps} = this.props

        this.props.deleteAccountDocument(modalProps.accountId, modalProps?.document?.id).then((response) => {
            if (response.success === true) {
                this.props.getAccountDocuments(modalProps.accountId);
                toastr.success(modalProps.document.name + ' deleted successfully', { timeOut: 2000, position: 'top-center' });
                this.props.hideModal()
            } else {
                let errorMessage = 'Something went wrong';
                if (response && response.error && response.error.message) errorMessage = response.error.message;
                toastr.error(errorMessage, { timeOut: 2000, position: 'top-center' });
            }
        })
    }


    render() {
        const { isCreating, isSubmitting } = this.state
        const { modalProps } = this.props
        return (
            <>
                {modalProps.type !== "delete" &&
                    <>
                    <div className="modal" style={{display: 'block'}} tabIndex="-1" role="dialog">
                        <Formik
                            initialValues={{
                                document: '',
                                description: modalProps?.document?.description || '',
                                name: modalProps?.document?.name || '',
                                restricted: modalProps?.document?.restricted || false
                            }}
                            validationSchema={this.DocumentSchema}
                            render={({
                                         handleChange,
                                         handleSubmit,
                                         values,
                                         errors,
                                         touched,
                                         isSubmitting,
                                         setFieldValue
                                     }) => (
                                <form className="documents-panel-form" onSubmit={handleSubmit}>
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    {modalProps.type === "create" ? "Add Document" : "Edit Document"}
                                                </h5>
                                                <button onClick={() => this.props.hideModal()} type="button"
                                                        className="close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                {modalProps.type === "create" ?
                                                    <>
                                                        {modalProps.canViewRestricted &&
                                                            <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end', gap:'1vw'}}>
                                                                <span style={{paddingTop:'2px'}}>Restricted</span>
                                                                <div className="checkbox-slider checkbox-slider--b-flat">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={values.restricted}
                                                                            onClick={() => {
                                                                                setFieldValue('restricted', !values.restricted)
                                                                            }}
                                                                        />
                                                                        <span>&nbsp;</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        }

                                                        <Dropzone
                                                            multiple={false}
                                                            disabled={isCreating}
                                                            onDrop={acceptedFiles => {
                                                                setFieldValue("document", acceptedFiles[0])
                                                                setFieldValue("name", acceptedFiles[0].name)
                                                            }}
                                                        >
                                                            {({
                                                                  getRootProps,
                                                                  getInputProps,
                                                                  isDragActive,
                                                                  isDragAccept,
                                                                  isDragReject
                                                              }) => (
                                                                <div {...getRootProps()}
                                                                     className={"documents-panel-droparea" + (
                                                                         isDragActive && isDragAccept ? " documents-panel-droparea-dragging-valid" :
                                                                             isDragActive && isDragReject ? " documents-panel-droparea-dragging-invalid" :
                                                                                 !isEmpty(values.document) ? " documents-panel-droparea-accepted" :
                                                                                     errors.document && touched.document ? " documents-panel-droparea-required" :
                                                                                         ""
                                                                     ) + (
                                                                         isCreating ? " documents-panel-droparea-disabled" : ""
                                                                     )}
                                                                >
                                                                    <input {...getInputProps()} />
                                                                    <i className="fas fa-upload"/>
                                                                    <p data-text={!isEmpty(values.document) ? values.name : "Drag and Drop Files or Click to Upload Files"}/>
                                                                </div>
                                                            )}
                                                        </Dropzone>
                                                        <div className="form-group">
                                                            <label>Name</label>
                                                            <div className="input-group">
                                                                <input
                                                                    className={"form-control" + (errors.name && touched.name ? ' is-invalid' : '')}
                                                                    type="text"
                                                                    id="name"
                                                                    name="name"
                                                                    placeholder={!isEmpty(values.name) ? values.name : "Enter Name"}
                                                                    onChange={handleChange}
                                                                    value={values.name}
                                                                    disabled={isCreating}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Description</label>
                                                            <div className="input-group">
                                                                <input
                                                                    className={"form-control" + (errors.description && touched.description ? ' is-invalid' : '')}
                                                                    type="text"
                                                                    id="description"
                                                                    name="description"
                                                                    placeholder="Enter Description"
                                                                    onChange={handleChange}
                                                                    value={values.description}
                                                                    disabled={isCreating}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>

                                                        {modalProps.canViewRestricted &&
                                                            <div style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                justifyContent: 'flex-end',
                                                                gap: '1vw'
                                                            }}>
                                                                <span style={{paddingTop: '2px'}}>Restricted</span>
                                                                <div
                                                                    className="checkbox-slider checkbox-slider--b-flat">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            // disabled={!this.checkIsCategoryActive() || isDisabled}
                                                                            checked={values.restricted}
                                                                            onClick={() => {
                                                                                setFieldValue('restricted', !values.restricted)
                                                                            }}
                                                                        />
                                                                        <span>&nbsp;</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        }
                                                        <div className="form-group">
                                                            <label>Name</label>
                                                            <div className="input-group">
                                                                <input
                                                                    className={"form-control" + (errors.name && touched.name ? ' is-invalid' : '')}
                                                                    type="text"
                                                                    id="name"
                                                                    name="name"
                                                                    placeholder="Enter Name"
                                                                    onChange={handleChange}
                                                                    value={values.name}
                                                                    disabled={isCreating}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Description</label>
                                                            <div className="input-group">
                                                                <input
                                                                    className={"form-control" + (errors.description && touched.description ? ' is-invalid' : '')}
                                                                    type="text"
                                                                    id="description"
                                                                    name="description"
                                                                    placeholder="Enter Description"
                                                                    onChange={handleChange}
                                                                    value={values.description}
                                                                    disabled={isCreating}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                            <div className="modal-footer">
                                                <button onClick={() => this.props.hideModal()} className="btn"
                                                        type="button">
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={() => modalProps.type === "create" ? this.handleCreateDocument(values) : this.handleEditDocument(values)}
                                                    className="btn btn-primary"
                                                    disabled={(!values.document && !values.description && !values.name) || this.state.isSubmitting}
                                                >
                                                    {modalProps.type === "create" ? "Add Document" : "Save"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        />
                    </div>
                    <div className="modal-backdrop show" tabIndex="1"/>
                    </>
                }
                {modalProps.type === "delete" &&
                    <>
                    <div className="modal" style={{display: 'block'}} tabIndex="-1" role="dialog">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Delete Document
                                    </h5>
                                    <button onClick={() => this.props.hideModal()} type="button"
                                            className="close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>Are you sure you want to delete this document?</p>
                                    <p>{modalProps?.document?.name}</p>
                                </div>
                                <div className="modal-footer">
                                    <button onClick={() => this.props.hideModal()} className="btn"
                                            type="button">
                                        Cancel
                                    </button>
                                    <button onClick={() => this.handleDeleteDocument()} className="btn btn-primary">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop show" tabIndex="1"/>
                    </>
                }
            </>
        )
    }
}


const mapStateToProps = (state) => {
    const modalProps = getModalData(state).modalProps;
    return {
        modalProps
    };
};

const mapDispatchToProps = {
    hideModal,
    createAccountDocument,
    editAccountDocument,
    getAccountDocuments,
    deleteAccountDocument
};
export default connect(mapStateToProps, mapDispatchToProps)(AddDocumentModal);

